import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function WhyItDidntWork() {
  const reasons = ['Los consejos de internet son contradictorios y te hacen sentir culpable.', 'El método "Cry-it-out" eleva el cortisol del bebé y tu nivel de ansiedad.', 'Las rutinas rígidas no tienen en cuenta que la vida con un bebé es impredecible.', 'Intervienes demasiado rápido en los micro-despertares, impidiendo que tu bebé practique su propia autonomía.', 'Ignoras las "ventanas de sueño" biológicas, intentando dormir a un bebé que ya está sobreestimulado.'];
  return <section className="py-24 bg-cream" data-id="element-165">
      <div className="max-w-4xl mx-auto px-6" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-168">
            Por qué lo que intentaste no funcionó
          </h2>
          <div className="w-16 h-px bg-amber mx-auto" data-id="element-169"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-170">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-navy/5" data-id="element-171">
              <AlertCircle className="w-6 h-6 text-rose shrink-0 mt-0.5 mr-4" data-id="element-172" />
              <p className="text-navy/80 text-lg" data-id="element-173">{reason}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}